import React, { useState, useEffect } from "react";
import assets from "../assets/imgs";
import InfoBox from "./InfoBox";
import Pagination from "./Pagination";
import MyPageAttendCard2 from "./MyPageAttendCard2";
import MyPageShowAllBox from "./MyPageShowAllBox";
import config from "../config/config";
const API_URL = config.API_URL;

function ManagerMyPageAttendList({style}) {
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const itemsPerPage = 3; // 페이지당 항목 수
  const [selectedContent, setSelectedContent] = useState(1);
  const [loading, setLoading] = useState(true);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [attendList, setAttendList] = useState([]);
  const [absenceList, setAbsenceList] = useState([]);

  const select1Text = "출퇴근 근황";
  const select2Text = "출퇴근 누락 명단";
  const select1RetailText = "출석률";
  const select2RetailText = "출석률";


  const dummyAttendList = [
    { id: 1, name: "스밈 팩토리", date: new Date("2024-05-05"), ratio: 20 },
    { id: 2, name: "스밈 팩토리", date: new Date("2024-05-04"), ratio: 30 },
  ];

  const dummyAbsenceList =[
    { id: 1, name: "스밈 팩토리2", date: new Date("2024-06-05"), ratio: 20 },
    { id: 2, name: "스밈 팩토리2", date: new Date("2024-07-04"), ratio: 30 },
  ];

  const handleContentChange = (value) =>{
    setSelectedContent(value);
    setCurrentPage(1);
  }

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/commute/getMypageCommute`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.attendList.map((row, index) => ({
          id: index + 1,
          name: row.name || '알 수 없음',
          date : row.date || '1999-01-01',
          ratio: row.ratio || 0, 
        }));
        const formattedData2 = result.value.absenceList.map((row, index) => ({
          id: index + 1,
          name: row.name || '알 수 없음',
          date : row.date || '1999-01-01',
          ratio: row.ratio || 0, 
        }));

        setAttendList(formattedData);
        setAbsenceList(formattedData2);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // 완료 날짜를 기준으로 오래된 순으로 정렬
  const sortedPrograms = [
    ...((selectedContent == 1) ? attendList : absenceList)].sort((a, b) => new Date(a.date) - new Date(b.date));

  // 현재 페이지에 표시할 항목 계산
  const startIndex = (currentPage - 1) * itemsPerPage;
  const items = sortedPrograms.slice(startIndex, startIndex + itemsPerPage);

  // 총 페이지 수 계산
  const totalPages = Math.ceil(sortedPrograms.length / itemsPerPage);

  return (
    <>
      {loading ? (
          <p>Loading...</p>
        ):(
          <div className="commonComponent" style={{padding: "20px 32px 40px 32px", position:"relative", ...style, }}>
            <div style={styles.header}>
              <div style={styles.headerTitle}>
                <h2 className={selectedContent == 1 ? "font-s-head4-bold" : "font-s-head4-medium" }
                  style={{color: selectedContent == 1 ? "var(--primary-crimson_60)": "var(--grayscale_60)", cursor: "pointer"}}
                  onClick={() => handleContentChange(1)}>
                    {select1Text}</h2>
                <div style={{width: "1px", height: "20px", backgroundColor: "var(--grayscale_50)", margin: "5px 0px"}}></div>
                <h2 className={selectedContent == 2 ? "font-s-head4-bold" : "font-s-head4-medium" }
                  style={{color: selectedContent == 2 ? "var(--primary-crimson_60)": "var(--grayscale_60)", cursor: "pointer"}}
                  onClick={() => handleContentChange(2)}>
                    {select2Text}</h2>
                <InfoBox description={selectedContent == 1 ? 
                  `<div style="font-family: 'Arial', sans-serif; color: #333;">
                    <h2 style="font-size: 24px; margin-bottom: 12px; color: black; text-align:center;">출퇴근 근황</h2>
                    <ul style="list-style: none; padding: 0;">
                      <li style="margin-bottom: 8px;">
                        🔹 <strong>월 초:</strong> 평일 일수 대비 출석률이 50%를 넘는 기업이 표출됩니다.
                      </li>
                      <li style="margin-bottom: 8px;">
                        🔹 <strong>월 말:</strong> 출석일이 12일 이상인 기업이 표출됩니다.
                      </li>
                      <li style="margin-bottom: 8px;">
                        🔹 <strong>출석률이 높은 기업 순</strong>으로 표출됩니다.
                      </li>
                    </ul>
                    <p style="margin-top: 16px; font-size: 14px; color: #666;">
                      ※ <em>공휴일인 평일의 경우에도 평일로 간주합니다.</em>
                    </p>
                  </div>
                  ` 
                  : `<div style="font-family: 'Arial', sans-serif; color: #333;">
                      <h2 style="font-size: 24px; margin-bottom: 12px; color: black; text-align:center;">출퇴근 누락 근황</h2>
                      <ul style="list-style: none; padding: 0;">
                        <li style="margin-bottom: 8px;">
                          🔸 <strong>월 초:</strong> 평일 일수 대비 출석률이 50% 미만인 기업이 표출됩니다.
                        </li>
                        <li style="margin-bottom: 8px;">
                          🔸 <strong>월 말:</strong> 출석일이 12일 미만인 기업이 표출됩니다.
                        </li>
                        <li style="margin-bottom: 8px;">
                          🔸 <strong>출석률이 낮은 기업 순</strong>으로 표출됩니다.
                        </li>
                      </ul>
                      <p style="margin-top: 16px; font-size: 14px; color: #666;">
                        ※ <em>공휴일인 평일의 경우에도 평일로 간주합니다.</em>
                      </p>
                    </div>`}/>
              </div>
              
              <p className="font-body3-medium"
                style={{textDecorationLine:"underline", color:"var(--grayscale_60)", cursor:"pointer"}} 
                onClick={openModal}>전체보기</p>
            </div>
            <div style={styles.contents}>
              {items.map((program, index) => (
                <MyPageAttendCard2 key={program.id} program={program} retailText={(selectedContent === 1 ? select1RetailText : select2RetailText)}/>
                // <div key={program.id} style={{
                //   ...styles.card,
                //   // ...(index === maxDisplay - 2 ? { opacity:  0.8} : {}),
                //   // ...(index === maxDisplay - 1 ? { opacity:  0.1} : {}), // 마지막 카드에만 적용
                //   }}>
                //   {/* D-Day 표시 */}
                //   <div style={styles.cardLeft}>
                //     <div style={styles.info}>
                //       <div className="font-body2-semibold" style={styles.programName}>{program.name}</div>
                //     </div>              
                //     <div className="font-body4-medium" style={styles.period}>{program.date}</div>
                //   </div>
                //   {/* 메뉴 버튼 */}
                //   <p className="font-body4-medium" style={{color: "var(--grayscale_70)"}}>{(selectedContent == 1) ? '출석률' : '누락률'}{program.ratio}%</p>
                // </div>
              ))}
            </div>
            {/* 페이지네이션 */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              style= {{position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",}}
            />
            {isModalOpen && <MyPageShowAllBox 
              title={selectedContent == 1 ? select1Text : select2Text}
              data={((selectedContent == 1) ? attendList : absenceList)} 
              retailText={(selectedContent === 1 ? select1RetailText : select2RetailText)} 
              onClose={closeModal}/>}
          </div>
        )
      }
    </>
  );
}
const styles ={
  header: {
    display: "flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom: "15px",
  },
  headerTitle: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  contents: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  dDay: {
    backgroundColor: "var(--main-orange_10)",
    padding: "4px 12px",
    borderRadius: "16px",
    color: "var(--main-orange_70)",
  },
  firstDDay:{
    backgroundColor: "var(--main-red_10)",
    color: "var(--main-red_70)",
  },
  // dDayText: {
  //   color: "#D22E59",
  // },
  
  // card: {
  //   boxSizing: "border-box",
  //   display: "flex",
  //   justifyContent: "space-between",
  //   alignItems: "center",
  //   padding: "18px 20px 12px 20px",
  //   borderRadius: "4px",
  //   backgroundColor: "#fff",
  //   boxShadow: "0px 4px 8px 0px rgba(157, 163, 191, 0.10)",
  //   borderLeft: "3px solid var(--primary-crimson_30)",
  // },
  // cardLeft: {
  //   flex: "1",
  //   display: "flex",
  //   flexDirection: "column",
  //   alignItems: "flex-start",
  //   gap: "8px",
  // },
  // info: {
  //   display: "flex",
  //   gap: "8px",
  // },
  // programName: {
  //   color: "var(--grayscale_100)",
  //   display: "flex",
  //   alignItems: "center",

  // },
  // period: {
  //   color: "var(--grayscale_80)",
  // },
}
export default ManagerMyPageAttendList;